import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ErrorMessage from "../../components/ErrorMessage";
import Main from "../../components/Main";
import SideMenu from "../../components/SideMenu";
import Spacer from "../../components/Spacer";
import { IApplicationState } from "../../store";
import { Container, Content } from "./styles";
import CustomTableSelect from "../../components/CustomTableSelect";
import { usersListRequest } from "../../store/users/slice";
import { sweepsSaveGuestRequest } from "../../store/sweeps/slice";
import { useMatch } from "react-router";

const GuestMember: React.FC = () => {

    const route = useMatch('/add-member/:idSweep/:idMember/form');

    const routeRegister = useMatch('/add-member/:idSweep/form');

    const idSweep = route?.params.idSweep || routeRegister?.params.idSweep;

    const users = useSelector((state: IApplicationState) => state.users)

    const sweeps = useSelector((state: IApplicationState) => state.sweeps.data.find(sweep => sweep.id === idSweep))

    const { t } = useTranslation();

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(usersListRequest(undefined))
    }, [dispatch]);



    return <Container id="container">
        <Content>
            <SideMenu />
            <Main>
                <h1>{t("pages.users.select_title")}</h1>

                <Spacer size={20} />
                {users.isLoading && <React.Fragment>
                    <p>{t("pages.users.loading")}</p>
                </React.Fragment>}

                <Spacer size={20} />
                {!users.isLoading && !users.error && users.data.length === 0 && (
                    <React.Fragment>
                        <ErrorMessage>
                            {t("pages.users.not_found")}
                        </ErrorMessage>
                    </React.Fragment>
                )}

                <Spacer size={10} />

                {!users.isLoading && !users.error && users.data.length > 0 && <React.Fragment>
                    <CustomTableSelect>
                        <thead>
                            <tr>
                                <th style={{ minWidth: 250 }}>{t("pages.users.name")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.data.map((user) => <tr key={`user-status-${user.id}`}>
                                <React.Fragment>
                                    <td onClick={() => {
                                        dispatch(sweepsSaveGuestRequest({
                                            id: "",
                                            idUser: user.id,
                                            sweepId: sweeps?.id || "",
                                            name: user.name
                                        }));
                                    }}>
                                        {user.name}
                                        {user.error && <p>{user.error.message}</p>}
                                    </td>
                                </React.Fragment>
                            </tr>)}
                        </tbody>
                    </CustomTableSelect>
                </React.Fragment>}
            </Main>
        </Content>
    </Container>
}

export default GuestMember;